(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define('locationHelper',['./stringHelper'], (StringHelper) => {
      global.LocationHelper = factory(global, StringHelper);
      return global.LocationHelper;
    });
  } else if (typeof exports === 'object') {
    const handler = factory(global, global.StringHelper);
    global.LocationHelper = handler;
    module.exports = handler;
  } else {
    global.LocationHelper = factory(global, global.StringHelper);
  }
}(typeof window !== 'undefined' ? window : {}, (global, StringHelper) => {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
   * Enumeration for completion suggestion types.
   */
  const completionSuggestionType = {
    neighborhood: 'Neighborhood',
    countyEquivalent: 'CountyEquivalent',
    postalCode: 'PostalCode',
    city: 'City',
    schoolDistrict: 'SchoolDistrict',
    marketAreaPopularlyNamedRegion: 'MarketAreaPopularlyNamedRegion'
  };

  /**
   * Formats the search text based on the location type.
   * @param {Object} location - The location object.
   * @returns {string} The formatted search text.
   */
  function getFormattedSearchText(location) {
    if (!location) {
      return '';
    }

    const locationType = location.locationType;

    let formattedSearchText = '';

    switch (locationType) {
      case completionSuggestionType.neighborhood: {
        formattedSearchText = [
          `${location.locationName} ${StringHelper.capitalizeFirstLetter(locationType)}`,
          StringHelper.capitalizeFirstLetter(location.marketAreaName),
          StringHelper.capitalizeFirstLetter(location.stateEquivalentAbbreviation)
        ].join(', ');
        break;
      }
      case completionSuggestionType.countyEquivalent: {
        formattedSearchText = `${location.county} County, ${location.stateEquivalentAbbreviation}`;
        break;
      }
      case completionSuggestionType.postalCode: {
        formattedSearchText = `${location.postalCode || ''}`;
        break;
      }
      case completionSuggestionType.city: {
        formattedSearchText = `${location.city}, ${location.stateEquivalentAbbreviation}`;
        break;
      }
      case completionSuggestionType.schoolDistrict: {
        formattedSearchText = `${location.locationName || ''}`;
        break;
      }
      case completionSuggestionType.marketAreaPopularlyNamedRegion: {
        const stateAbbreviation = location.marketState || location.stateEquivalentAbbreviation || '';
        formattedSearchText = `${location.marketAreaName}, ${stateAbbreviation} Area`;
        break;
      }
      default: {
        formattedSearchText = '';
        break;
      }
    }

    const normalizedText = StringHelper.normalizeSpaces(formattedSearchText);
    return normalizedText;
  }

  /**
   * Formats location parameters for a query string.
   * @param {Object} data - The location data.
   * @returns {string} The formatted location parameters.
   */
  function getFormattedLocationParams(data) {
    const market = data.marketAreaId;
    const state = data.marketState;
    const searchText = getFormattedSearchText(data);
    const urlEncodedText = encodeURIComponent(searchText);

    return `market=${market}&state=${state}&searchtext=${urlEncodedText}`;
  }

  /**
   * Updates the 'Personal_1' cookie with the last search text.
   * @param {string} searchText - The last search text to store in the cookie.
   */
  function updateLastSearchCookie(searchText) {
    global.NewHomeSource.Modules.cookieHandler.createCookie('Personal', searchText, '', true);
  }

  return {
    completionSuggestionType,
    getFormattedSearchText,
    getFormattedLocationParams,
    updateLastSearchCookie
  };
}));

